export default {
    init() {
        this.popupRegistrationUpload();
       this.popupRegistrationDeleteUploadFromList();
       this.popupRegistrationDragFromList();
    },

    popupRegistrationUpload(){
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 16 * 1024 * 1024;
        let wrongFile = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-row .wrong-file-type');
        let uploadArea = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-box');
        let filesList = $('.fr-registration.pop-up .product-photo-upload-wrap--list');
        let importFileInput = $('.fr-registration.pop-up .product-img-file');

        importFileInput.on('change', function () {
            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');
                let filesAllowed = [];
                let countInvalid = false;
                let files = $(this)[0].files;

                for (let i = 0; i < files.length; i++) {
                    if(files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else{
                        countInvalid = true;
                    }
                }

                for (let i = 0; i < filesAllowed.length; i++ ) {
                    let numberOfChildren = filesList.children().length;
                    if(numberOfChildren < 30) {
                        filesList.append(`
                        <li class="item">${filesAllowed[i].name}<span data-name="${filesAllowed[i].name}"></span></li>
                    `);
                    }
                }

                if(countInvalid == true ){
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }
            }
        });
    },

    popupRegistrationDeleteUploadFromList() {
        $('body').on('click', '.fr-registration.pop-up .product-photo-upload-wrap--list .item span' ,function () {
            $(this).parent().remove();
        });
    },

    popupRegistrationDragFromList() {
        
        $('.fr-registration.pop-up .product-photo-upload-wrap--list .item').droppable({
            cursor: 'move',
            greedy: true,
            connectToSortable: ".fr-registration.pop-up .product-photo-upload-wrap--list",
        });
        $('.fr-registration.pop-up .product-photo-upload-wrap--list').sortable({
            revert: true,
        });
    },
}
